import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=12d7210d&scoped=true&"
import script from "./vote.js?vue&type=script&lang=js&"
export * from "./vote.js?vue&type=script&lang=js&"
import style0 from "./vote.scss?vue&type=style&index=0&id=12d7210d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7210d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
